import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await api.get('/auth/me');
        setAdmin(response.data.admin);
        setIsAuthenticated(true);
      } catch (error) {
        localStorage.removeItem('token');
        setAdmin(null);
        setIsAuthenticated(false);
      }
    }
    setLoading(false);
  };

  const login = async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    const { token, admin: adminData } = response.data;

    localStorage.setItem('token', token);
    setAdmin(adminData);
    setIsAuthenticated(true);

    return adminData;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setAdmin(null);
    setIsAuthenticated(false);
  };

  const googleLogin = async (credential) => {
    const response = await api.post('/auth/google', { credential });
    const { token, admin: adminData } = response.data;

    localStorage.setItem('token', token);
    setAdmin(adminData);
    setIsAuthenticated(true);

    return adminData;
  };

  const value = {
    admin,
    loading,
    isAuthenticated,
    login,
    googleLogin,
    logout,
    checkAuth
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
